export const dispatchLocalStorage = ({ key, value, callback }: any): void => {
  localStorage.setItem(key, value)
  if (callback) callback({ key, value })
  window.dispatchEvent(new Event('storage'))
}

/** Don't remove */
// const restoreLocalStorage = () => {

// const localStorageBKP = {
//   auth: '{"email":"stage-test+inverorganic@mundi.io","id":"c54f32bd-96f5-40c9-8e1c-311dcb9793d5"}',
//   companyName: 'INVERORGANIC PRODUCE SAPI SA DE CV',
//   email: 'stage-test+inverorganic@mundi.io',
//   userId: 'c54f32bd-96f5-40c9-8e1c-311dcb9793d5',
//   userName: 'Jose Nicolas Camacho Toro',
// }

//   Object.keys(localStorageBKP).forEach((key) => {
//     localStorage.setItem(key, localStorageBKP[key])
//   })
// }
